import { CalendarQuestionIcon } from './CalendarQuestionIcon';

/**
 * author: Simran
 * id 1A7293FC-E6E7-4C86-8919-32D0C5F60B08
 * name calendar-question
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-question.svg
 * tags
 * - Date / Time 
 */
export const CalendarRsvpIcon = CalendarQuestionIcon;
export default CalendarRsvpIcon